"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _brightDates = require("bright-dates");

var _propTypes = require("prop-types");

var _reactOnclickoutside = _interopRequireDefault(require("react-onclickoutside"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _colors = _interopRequireDefault(require("../../constants/colors"));

var _vars = _interopRequireDefault(require("../../constants/vars"));

var _zIndex = _interopRequireDefault(require("../../constants/z-index"));

var _breakpoints = _interopRequireDefault(require("../../constants/breakpoints"));

var _DayPickerPanel = _interopRequireDefault(require("../DayPickerPanel"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\t\t\t\t\t\twidth: 360px;\n\t\t\t\t  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\t\t\t\t\t\twidth: 60%;\n\t\t\t\t\t\tleft: 20%;\n\t\t\t\t\t\ttop: 15%;\n\t\t\t\t  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tposition: relative;\n\tz-index: ", ";\n\toverflow: hidden;\n\theight: auto;\n\tbackground-color: ", ";\n\tbox-shadow: ", ";\n\twidth: 100%;\n\n\t@media (min-width: ", ") {\n\t\tposition: absolute;\n\t\t", ";\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var DayRangeContainer = _styledComponents.default.div(_templateObject(), _zIndex.default.MODAL, _colors.default.white, _vars.default.boxShadow, _breakpoints.default.tablet, function (props) {
  return props.inModal ? (0, _styledComponents.css)(_templateObject2()) : (0, _styledComponents.css)(_templateObject3());
});

DayRangeContainer.displayName = 'DayRangeContainer';

var WithDayPicker =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(WithDayPicker, _React$Component);

  function WithDayPicker() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = WithDayPicker.prototype;

  _proto.handleClickOutside = function handleClickOutside() {
    this.props.onClickOutside();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        isOpen = _this$props.isOpen,
        inModal = _this$props.inModal,
        props = _objectWithoutPropertiesLoose(_this$props, ["isOpen", "inModal"]);

    return _react.default.createElement(_react.default.Fragment, null, isOpen ? _react.default.createElement(DayRangeContainer, {
      inModal: inModal,
      "data-testid": "dayrange-container"
    }, _react.default.createElement(_DayPickerPanel.default, props)) : null);
  };

  return WithDayPicker;
}(_react.default.Component);

WithDayPicker.displayName = 'WithDayPicker';
WithDayPicker.propTypes = {
  isOpen: _propTypes.bool.isRequired,
  onApply: _propTypes.func.isRequired,
  onClickOutside: _propTypes.func.isRequired,
  inModal: _propTypes.bool,
  month: _propTypes.number,
  year: _propTypes.number,
  view: _propTypes.string,
  yearRange: (0, _propTypes.shape)({
    min: _propTypes.number,
    max: _propTypes.number
  }),
  yearsToDisplay: _propTypes.number,
  dateRange: _propTypes.bool,
  onClear: _propTypes.func,
  range: (0, _propTypes.shape)({
    from: (0, _propTypes.instanceOf)(Date),
    to: (0, _propTypes.instanceOf)(Date)
  }).isRequired,
  disabledDays: _propTypes.array,
  // eslint-disable-line react/forbid-prop-types
  shortcuts: (0, _propTypes.oneOf)(['today', 'current', 'last']),
  GA: (0, _propTypes.shape)({
    category: _propTypes.string,
    actionId: _propTypes.string
  }).isRequired,
  recordValue: _propTypes.bool
};
WithDayPicker.defaultProps = {
  inModal: false,
  view: 'calendar',
  month: (0, _brightDates.date)().month(),
  year: (0, _brightDates.date)().year(),
  yearRange: {
    min: (0, _brightDates.date)().subtract(1, 'years').year(),
    max: (0, _brightDates.date)().add(1, 'years').year()
  },
  onClear: undefined,
  yearsToDisplay: null,
  dateRange: false,
  disabledDays: [],
  shortcuts: undefined,
  recordValue: false
};

var _default = (0, _reactOnclickoutside.default)(WithDayPicker);

exports.default = _default;